import axios from "axios";
import * as Icons from "heroicons-react";
import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useFieldArray, useForm } from "react-hook-form";
import { Toaster } from "react-hot-toast";
// import Resizer from "react-image-file-resizer";
import { useDispatch, useSelector } from "react-redux";
import logo from "../../../logo.svg";
import {
  useAddSettingsMutation,
  useSettingsQuery,
  useUpdateSettingsMutation,
} from "../../../services/settingsApi";
import { JwtReValidate, signInUser } from "../../Utility/Auth";
import { notify } from "../../Utility/Notify";
import { useUploadPhotoMutation } from "../../../services/photoApi";
//icons
import { CiSaveUp2 } from "react-icons/ci";
import { IoSave } from "react-icons/io5";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaYoutube,
  FaTwitter,
  FaTiktok,
  FaPinterestP,
  FaWhatsapp,
  FaTelegram,
} from "react-icons/fa6";

const FooterSettings = () => {
  const user = signInUser();
  const { aamarId } = user;
  const lang = useSelector((state) => state.languageReducer);

  console.log("USER::>>", user);
  const { data: settings, isSuccess, refetch } = useSettingsQuery(aamarId);
  const [addSettings] = useAddSettingsMutation();
  const [isEcommerceToggled, setIsEcommerceToggled] = useState(false);
  const [selectedImage, setSelectedImage] = useState("image1");
  const [showPayments, setShowPayments] = useState(false);
  const [contactInfoEnabled, setContactInfoEnabled] = useState(false);

  const { register, handleSubmit, setValue } = useForm();

  // Handle form submission
  const onSubmit = async (data, message) => {
    const payload = {
      ...data,
      aamarId: aamarId,
    };
    // console.log("Payload for submission:", data);
    const response = await addSettings(payload);
    // console.log("Response", response);
    if (response?.data) {
      await JwtReValidate();

      refetch();
      notify(message, "success");
    } else {
      notify("Failed to add settings.", "error");
    }
  };

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setShowPayments(isChecked);
    setValue("footer.showPaymentLogos", isChecked); // Update form value too
  };
  // Set the form value when toggle changes
  useEffect(() => {
    setValue("footer.contactInfo", contactInfoEnabled);
  }, [contactInfoEnabled, setValue]);

  const handleToggle = (e) => {
    const value = e.target.checked;
    setContactInfoEnabled(value);
    setValue("footer.contactInfo", value);
  };

  return (
    <div>
      {/* Footer Settings Section */}
      <form
        style={{ marginTop: "80px" }}
        onSubmit={handleSubmit((data) =>
          onSubmit(data, "Footer settings updated successfully!")
        )}
      >
        <div className="mb-4">
          <div className="d-flex justify-content-between">
            <h5 className="d-flex align-content-center gap-2">
              Footer Settings
            </h5>
          </div>
          <hr />

          {/* Footer Layout Selection */}
          <div className="d-flex justify-content-between mb-4">
            <span className="d-flex align-content-center gap-2">
              Footer Layout
            </span>
            <div className="image-selection d-flex gap-3">
              {[
                { key: "image1", label: "Layout 1" },
                { key: "image2", label: "Layout 2" },
                { key: "image3", label: "Layout 3" },
              ].map((item, index) => (
                <div
                  key={index}
                  onClick={() =>
                    !isEcommerceToggled && setSelectedImage(item.key)
                  }
                  className={`theme-option text-center ${
                    selectedImage === item.key ? "selected" : ""
                  }`}
                  style={{
                    border:
                      selectedImage === item.key
                        ? "1px solid #F2652D"
                        : "1px solid #ccc",
                    padding: "5px",
                    cursor: isEcommerceToggled ? "not-allowed" : "pointer",
                    borderRadius: "8px",
                    opacity: isEcommerceToggled ? 0.5 : 1,
                  }}
                >
                  <img
                    src={logo}
                    alt={item.label}
                    className="theme-image mb-2"
                    style={{ width: "250px", height: "150px" }}
                  />
                  <div style={{ fontSize: "14px", color: "#333" }}>
                    {item.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="row mb-3">
            {/* Contact Info Toggle */}
            <div className="col-sm-3">
              <label>Show Contact Info</label>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="footerContactInfo"
                  {...register("footer.contactInfo")}
                  checked={contactInfoEnabled}
                  onChange={handleToggle}
                />
                <label className="form-check-label" htmlFor="footerContactInfo">
                  {!contactInfoEnabled ? "Enable" : "Disable"}{" "}
                </label>
              </div>
            </div>

            {/* Payment Logos Toggle */}
            <div className="col-sm-3">
              <label>Show Payment Logos</label>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="footerPaymentLogos"
                  {...register("footer.paymentLogos")}
                  onChange={handleCheckboxChange}
                />
                <label
                  className="form-check-label"
                  htmlFor="footerPaymentLogos"
                >
                  Enable
                </label>
              </div>
            </div>

            {/* Payment Method Options */}
            {showPayments && (
              <div className="mb-4 mt-4 ps-3 border-start">
                <label className="mb-2">Select Payment Methods</label>
                <div className="row">
                  {[
                    { id: "bkash", label: "bKash" },
                    { id: "nagad", label: "Nagad" },
                    { id: "rocket", label: "Rocket" },
                    { id: "dbbl", label: "DBBL" },
                    { id: "visa", label: "VISA / Mastercard" },
                    { id: "other", label: "Other" },
                  ].map((method) => (
                    <div className="col-sm-6 mb-2" key={method.id}>
                      <input
                        type="checkbox"
                        className="form-check-input me-2"
                        id={method.id}
                        {...register(`footer.paymentMethods.${method.id}`)}
                      />
                      <label htmlFor={method.id}>{method.label}</label>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Social Media Links with Icons */}
          <div className="row mb-2">
            <div className="col-sm-6 mb-2">
              <label className="d-flex align-items-center gap-2 mb-1">
                <FaFacebookF className="me-1 " /> Facebook
              </label>
              <input
                type="text"
                className="form-control mb-2"
                placeholder="Facebook URL"
                disabled={!contactInfoEnabled}
                {...register("footer.socialLinks.facebook")}
              />
            </div>
            <div className="col-sm-6 mb-2">
              <label className="d-flex align-items-center gap-2 mb-1">
                <FaLinkedinIn className="me-1 " /> LinkedIn
              </label>
              <input
                type="text"
                className="form-control mb-2"
                placeholder="LinkedIn URL"
                disabled={!contactInfoEnabled}
                {...register("footer.socialLinks.linkedin")}
              />
            </div>
            <div className="col-sm-6 mb-2">
              <label className="d-flex align-items-center gap-2 mb-1">
                <FaInstagram className="me-1 " /> Instagram
              </label>
              <input
                type="text"
                className="form-control mb-2"
                placeholder="Instagram URL"
                disabled={!contactInfoEnabled}
                {...register("footer.socialLinks.instagram")}
              />
            </div>
            <div className="col-sm-6 mb-2">
              <label className="d-flex align-items-center gap-2 mb-1">
                <FaYoutube className="me-1 " /> YouTube
              </label>
              <input
                type="text"
                className="form-control mb-2"
                placeholder="YouTube URL"
                disabled={!contactInfoEnabled}
                {...register("footer.socialLinks.youtube")}
              />
            </div>
            <div className="col-sm-6 mb-2">
              <label className="d-flex align-items-center gap-2 mb-1">
                <FaTwitter className="me-1 " /> X (Twitter)
              </label>
              <input
                type="text"
                className="form-control mb-2"
                placeholder="X (Twitter) URL"
                disabled={!contactInfoEnabled}
                {...register("footer.socialLinks.x")}
              />
            </div>
            <div className="col-sm-6 mb-2">
              <label className="d-flex align-items-center gap-2 mb-1">
                <FaTiktok className="me-1 " /> TikTok
              </label>
              <input
                type="text"
                className="form-control mb-2"
                placeholder="TikTok URL"
                disabled={!contactInfoEnabled}
                {...register("footer.socialLinks.tiktok")}
              />
            </div>
            <div className="col-sm-6 mb-2">
              <label className="d-flex align-items-center gap-2 mb-1">
                <FaPinterestP className="me-1 " /> Pinterest
              </label>
              <input
                type="text"
                className="form-control mb-2"
                placeholder="Pinterest URL"
                disabled={!contactInfoEnabled}
                {...register("footer.socialLinks.pinterest")}
              />
            </div>
            <div className="col-sm-6 mb-2">
              <label className="d-flex align-items-center gap-2 mb-1">
                <FaWhatsapp className="me-1 " /> WhatsApp
              </label>
              <input
                type="text"
                className="form-control mb-2"
                placeholder="WhatsApp URL"
                disabled={!contactInfoEnabled}
                {...register("footer.socialLinks.whatsapp")}
              />
            </div>
            <div className="col-sm-6 mb-2">
              <label className="d-flex align-items-center gap-2 mb-1">
                <FaTelegram className="me-1 " /> Telegram
              </label>
              <input
                type="text"
                className="form-control mb-2"
                placeholder="Telegram URL"
                disabled={!contactInfoEnabled}
                {...register("footer.socialLinks.telegram")}
              />
            </div>
          </div>

          {/* Description and Copyright */}
          <div className="row mb-2">
            <label className="col-sm-4 col-form-label">
              Footer Description
            </label>
            <div className="col-sm-8">
              <textarea
                className="form-control"
                placeholder="Brief about your company"
                rows={3}
                {...register("footer.description")}
              />
            </div>
          </div>
          <div className="row mb-2">
            <label className="col-sm-4 col-form-label">Copyright Text</label>
            <div className="col-sm-8">
              <input
                type="text"
                className="form-control"
                placeholder="e.g., © 2024 Aamar Dokan. All rights reserved."
                {...register("footer.copyright")}
              />
            </div>
          </div>

          {/* Quick Links (Static example) */}
          <div className="row mb-2">
            <label className="col-sm-4 col-form-label">Quick Link 1</label>
            <div className="col-sm-8">
              <input
                type="text"
                className="form-control"
                placeholder="e.g., /about"
                {...register("footer.quickLinks.link1")}
              />
            </div>
          </div>

          {/* Submit Button */}
          <div className="d-flex justify-content-end mt-4">
            <button
              type="submit"
              className="btn btn-dark d-flex justify-content-center align-items-center gap-2"
            >
              <IoSave size={16} className="me-1 " />
              <span>Save</span>
            </button>
          </div>
        </div>
      </form>
      <Toaster position="bottom-right" />
    </div>
  );
};

export default FooterSettings;
